import { Injectable, Inject, Optional } from "@angular/core";
import { ICodeViewConfigProvider, ICodeViewConfiger, IDE_CODE_VIEW_CONFIGER } from '../config/preset-configer';
import { ContextService } from "./context.service";

@Injectable()
export class PresetConfigService {

  private provider: ICodeViewConfigProvider = null;

  constructor(
    private context: ContextService,
    @Optional() @Inject(IDE_CODE_VIEW_CONFIGER) private configer: ICodeViewConfiger
  ) { }

  /**
   * 获取配置服务并缓存
   * @remarks 获取预置的配置服务，可能为空
   */
  getPresetConfigProvider(): ICodeViewConfigProvider {
    if (this.provider) {
      return this.provider;
    }
    if (!this.configer) {
      return undefined;
    }
    const entryFilePath = this.context.entryFilePath.getValue();
    const configProvider = this.configer.getConfigProvider(entryFilePath);
    if (configProvider) {
      this.provider = configProvider;
      return configProvider;
    }
    return null;
  }

}
